import { Link } from 'react-router-dom'
import { Menu } from 'lucide-react'
import { useRedirect } from '@/contexts/redirect-context'

interface TopBarProps {
  onMenuClick: () => void
}

export function TopBar({ onMenuClick }: TopBarProps) {
  const { openRedirect } = useRedirect()

  const handleJoinFree = () => {
    openRedirect()
  }

  return (
    <header className="flex items-center justify-between px-4 md:px-6 py-2.5 glass border-t-0 border-x-0">
      <div className="flex items-center gap-3">
        <MenuButton onClick={onMenuClick} />
        <Logo />
      </div>
      <button 
        onClick={handleJoinFree}
        className="px-3 py-1.5 rounded-lg text-sm font-medium text-black bg-white hover:bg-white/90 transition-colors"
      >
        Join Free
      </button>
    </header>
  )
}

function MenuButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="md:hidden p-2 -ml-2 rounded-lg text-[#888] hover:text-white hover:bg-white/[0.05] transition-colors"
      aria-label="Open menu"
    >
      <Menu className="size-5" />
    </button>
  )
}

function Logo() {
  return (
    <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
      <img src="/pixelmaker_logo.svg" alt="Pixelmaker" className="size-5 brightness-0 invert" />
      <span className="text-lg font-bold tracking-tight text-white">
        Pixelmaker
      </span>
    </Link>
  )
}
